import React from 'react';
import styled from 'styled-components';
import { Alert, IconButton, Stack } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Label } from '../../components';
import { XERO_COLORS, XERO_SPACING, XERO_THEME_COLOR } from './xeroAuthStyles';

const CARD_PADDING = '20px';
const CARD_RADIUS = '14px';
const CHEVRON_ICON =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' fill='none'%3E%3Cpath d='M1 1.5 6 6.5 11 1.5' stroke='%236B7684' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")";

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${XERO_SPACING.text};
  padding: ${CARD_PADDING};
  border: 1px solid ${XERO_COLORS.border};
  border-radius: ${CARD_RADIUS};
  background-color: #ffffff;
`;

const AccountSelect = styled.select`
  width: 100%;
  padding: 14px 44px 14px 16px;
  border: 1px solid ${XERO_COLORS.inputBorder};
  border-radius: 12px;
  background-color: #ffffff;
  background-image: ${CHEVRON_ICON};
  background-repeat: no-repeat;
  background-position: right 16px center;
  color: ${XERO_COLORS.heading};
  font-size: 15px;
  box-sizing: border-box;
  appearance: none;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${XERO_THEME_COLOR};
    outline-offset: 1px;
  }
`;

const formatAccountLabel = ({ name, code }) => (code ? `${name} (${code})` : name);

const TenantHeader = ({ tenant, onClear, isClearable }) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" gap={XERO_SPACING.text}>
    <Label isRequired>{tenant.tenantName} ({tenant.tenantType})</Label>
    {isClearable && (
      <IconButton size="small" onClick={onClear} aria-label={`Clear bank account for ${tenant.tenantName}`}>
        <DeleteIcon fontSize="small" />
      </IconButton>
    )}
  </Stack>
);

export const XeroTenantAccountField = ({ tenant, accounts, selectedAccountId, onChange, onClear }) => (
  <Card>
    <TenantHeader tenant={tenant} onClear={onClear} isClearable={Boolean(selectedAccountId)} />
    <AccountSelect value={selectedAccountId} onChange={(event) => onChange(event.target.value)}>
      <option value="">-- No preferred bank account --</option>
      {accounts.map((account) => (
        <option key={account.accountId} value={account.accountId}>
          {formatAccountLabel(account)}
        </option>
      ))}
    </AccountSelect>
    {accounts.length === 0 && (
      <Alert severity="warning">No active bank accounts found for this organisation.</Alert>
    )}
  </Card>
);
